import { isNumber } from '@bitComponents/utils/common';
import { MOBILE_INSURANCE } from '../bitConstants/constants';
import { commonTypes } from './common';

export const types = {
  SAVE_QUERY_STRING: 'OFFER_REDUCER/SET_QUERY_STRING',
  SET_NEW_SECONDARY_PRODUCT_OFFERINGS: 'OFFER_REDUCER/SET_NEW_SECONDARY_PRODUCT_OFFERINGS',
  SET_NEW_SECONDARY_R2R: 'OFFER_REDUCER/SET_NEW_SECONDARY_R2R',
  SET_ACTUAL_PRODUCT_OFFERING: 'OFFER_REDUCER/SET_ACTUAL_PRODUCT_OFFERING',
  SAVE_NETFLIX_INFO: 'OFFER_REDUCER/SAVE_NETFLIX_INFO',
  SET_OTT_PRODUCTS: 'OFFER_REDUCER/SET_OTT_PRODUCTS',
  SAVE_OTT_PRODUCTS: 'OFFER_REDUCER/SAVE_OTT_PRODUCTS',
  CLEAN_UPGRADES_N_DOWNGRADES: 'OFFER_REDUCER/CLEAN_UPGRADES_N_DOWNGRADES',
  SAVE_R2R_SUBTYPE: 'OFFER_REDUCER/SAVE_R2R_SUBTYPE',
  SET_ACTUAL_R2R_INFO: 'OFFER_REDUCER/SET_ACTUAL_R2R_INFO',
  SET_R2R_INFO_PRICE: 'OFFER_REDUCER/SET_R2R_INFO_PRICE',
  SAVE_NEW_PRODUCT_OFFERINGS_TO_DOWNGRADE: 'OFFER_REDUCER/SAVE_NEW_PRODUCT_OFFERINGS_TO_DOWNGRADE'
};
const { NS_OPTION } = MOBILE_INSURANCE;

export const initialState = {
  r2rInfo: [],
  actualProductOffering: null,
  cardPaymentErrorCode: null,
  colorId: null,
  isDeviceIncluded: null,
  insurance: NS_OPTION,
  lmasProductOfferings: null,
  months: null,
  netflixObj: null,
  ottProductsArray: [],
  persistentOttProductsArray: [],
  parentProductId: null,
  productOffering: null,
  productOfferingAlt: null,
  productOfferingIsr: null,
  promotion: null,
  queryString: null,
  r2rType: null,
  r2rSubType: null,
  secondaryProductOfferings: [],
  storageId: null,
  subType: null,
  vval: null,
  cisi: null,
  parentProductType: null,
  productOfferingsToUpgrade: null,
  productOfferingsToDowngrade: null,
  netflixToDowngrade: null,
  modality: null,
  backToSchool: false,
  secondaryR2Rs: null,
  differentAccount: true,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const OfferReducer = (state = initialState, action) => {
  switch (action.type) {
    case commonTypes.SET_OFFER_INFO: {
      const {
        productOffering,
        productOfferingAlt,
        parentProductId,
        subType,
        promotion,
        productId,
        bonus,
        poR,
        storageId,
        colorId,
        months,
        productOfferingIsr,
        confirmationCo,
        cardPaymentErrorCode,
        r2rType,
        isDeviceIncluded,
        insurance,
        vval,
        secondaryProductOfferings,
        lmasProductOfferings,
        allPOsToBuy,
        cisi,
        parentProductType,
        alias,
        goToC2C,
        productOfferingsToUpgrade,
        productOfferingsToDowngrade,
        productOfferingsToDowngradeForPrices,
        netflixToDowngrade,
        speedId,
        modality,
        insurancePo,
        insuranceModality,
        backToSchool,
        swap,
        secondaryR2Rs,
        poit,
        resourceSpecId,
      } = action.payload;

      return {
        ...state,
        productOffering: productOffering || null,
        productOfferingAlt: productOfferingAlt || null,
        parentProductId: parentProductId || null,
        lmasProductOfferings: lmasProductOfferings || [],
        secondaryProductOfferings: secondaryProductOfferings || [],
        actualProductOffering: productOffering || null,
        subType: subType || null,
        promotion: promotion || null,
        productId: productId || null,
        bonus: bonus || null,
        poR: poR || null,
        storageId: storageId || null,
        colorId: colorId || null,
        months: months || null,
        productOfferingIsr: productOfferingIsr || null,
        confirmationCo: confirmationCo || null,
        cardPaymentErrorCode: cardPaymentErrorCode || null,
        r2rType: r2rType || null,
        isDeviceIncluded: isDeviceIncluded || null,
        insurance: insurance || NS_OPTION,
        vval: vval ? parseFloat(vval, 10) : '',
        allPOsToBuy: allPOsToBuy || [],
        cisi: cisi || null,
        parentProductType: parentProductType || null,
        alias,
        goToC2C,
        productOfferingsToUpgrade,
        productOfferingsToDowngrade,
        productOfferingsToDowngradeForPrices: productOfferingsToDowngradeForPrices || null,
        netflixToDowngrade,
        speedId,
        modality: modality || null,
        insurancePo: insurancePo || null,
        insuranceModality: insuranceModality || null,
        backToSchool: backToSchool || false,
        swap: swap || false,
        secondaryR2Rs: secondaryR2Rs || null,
        poit: poit || null,
        resourceSpecId: resourceSpecId || null,
      };
    }
    case types.SAVE_NETFLIX_INFO: {
      const { netflixObj } = action.payload;

      return {
        ...state,
        netflixObj,
      }
    }
    case types.SET_OTT_PRODUCTS: {
      const { ottProductsArray } = action.payload;

      return {
        ...state,
        ottProductsArray,
        persistentOttProductsArray: ottProductsArray,
      }
    }
    case types.SAVE_OTT_PRODUCTS: {
      const { ottProductsArray } = action.payload;

      return {
        ...state,
        ottProductsArray,
      }
    }
    case types.SET_ACTUAL_R2R_INFO: {
      const { r2rInfo } = action.payload;

      const newR2RArray = JSON.parse(JSON.stringify(state.r2rInfo));

      newR2RArray.push(r2rInfo);

      const hasDifferentR2RType = new Set(newR2RArray.map(obj => obj.r2rType)).size > 1;

      return {
        ...state,
        r2rInfo: newR2RArray,
        differentAccount: hasDifferentR2RType,
      }
    }
    case types.SET_R2R_INFO_PRICE: {
      const { poId, price } = action.payload;

      const newR2RArray = JSON.parse(JSON.stringify(state.r2rInfo));

      const r2rToChange = newR2RArray.find(obj => obj.poId === poId);

      const r2rToChangeIndex = newR2RArray.indexOf(r2rToChange);

      newR2RArray[r2rToChangeIndex].price = price;

      return {
        ...state,
        r2rInfo: newR2RArray,
      }
    }
    case types.SET_NEW_SECONDARY_PRODUCT_OFFERINGS: {
      const {
        newSecondaryProductOfferings,
      } = action.payload;
      return {
        ...state,
        secondaryProductOfferings: newSecondaryProductOfferings,
      };
    }
    case types.SET_NEW_SECONDARY_R2R: {
      const {
        newSecondaryR2R,
      } = action.payload;
      return {
        ...state,
        secondaryR2Rs: newSecondaryR2R,
      };
    }
    case types.SET_ACTUAL_PRODUCT_OFFERING: {
      const {
        productOffering,
      } = action.payload;
      return {
        ...state,
        actualProductOffering: productOffering,
      };
    }

    case types.SAVE_NEW_PRODUCT_OFFERINGS_TO_DOWNGRADE: {
      const {
        newProductOfferingsToDowngrade,
      } = action.payload;
      return {
        ...state,
        productOfferingsToDowngrade: newProductOfferingsToDowngrade,
      };
    }

    case types.SAVE_QUERY_STRING: {
      const {
        queryString,
      } = action.payload;
      return {
        ...state,
        queryString,
      };
    }
    case types.CLEAN_UPGRADES_N_DOWNGRADES: {
      return {
        ...state,
        productOfferingsToUpgrade: null,
        productOfferingsToDowngrade: null,
      }
    }
    case types.SAVE_R2R_SUBTYPE: {
      const {
        r2rSubType,
      } = action.payload;
      return {
        ...state,
        r2rSubType,
      };
    }
    default: return { ...state };
  }
};

export const actions = {
  saveQueryString: queryString => ({
    type: types.SAVE_QUERY_STRING,
    payload: {
      queryString,
    },
  }),
  setNewSecondaryProductOfferings: newSecondaryProductOfferings => ({
    type: types.SET_NEW_SECONDARY_PRODUCT_OFFERINGS,
    payload: {
      newSecondaryProductOfferings,
    },
  }),
  setNewSecondaryR2R: newSecondaryR2R => ({
    type: types.SET_NEW_SECONDARY_R2R,
    payload: {
      newSecondaryR2R,
    },
  }),
  setActualProductOffering: productOffering => ({
    type: types.SET_ACTUAL_PRODUCT_OFFERING,
    payload: {
      productOffering,
    },
  }),
  saveNetflixInfo: netflixObj => ({
    type: types.SAVE_NETFLIX_INFO,
    payload: {
      netflixObj,
    },
  }),
  setOTTProductsInfo: ottProductsArray => ({
    type: types.SET_OTT_PRODUCTS,
    payload: {
      ottProductsArray,
    },
  }),
  saveOTTProductsInfo: ottProductsArray => ({
    type: types.SAVE_OTT_PRODUCTS,
    payload: {
      ottProductsArray,
    },
  }),
  saveNewProductOfferingsToDowngrade: newProductOfferingsToDowngrade => ({
    type: types.SAVE_NEW_PRODUCT_OFFERINGS_TO_DOWNGRADE,
    payload: {
      newProductOfferingsToDowngrade,
    }
  }),
  cleanPOsToDowngradeNUpgrade: () => ({
    type: types.CLEAN_UPGRADES_N_DOWNGRADES,
  }),
  saveR2RSubtype: r2rSubType => ({
    type: types.SAVE_R2R_SUBTYPE,
    payload: {
      r2rSubType,
    },
  }),
  setActualR2RInfo: (r2rInfo) => ({
    type: types.SET_ACTUAL_R2R_INFO,
    payload: {
      r2rInfo
    },
  }),
  setR2RInfoPrice: (poId, price) => ({
    type: types.SET_R2R_INFO_PRICE,
    payload: {
      poId,
      price,
    },
  }),
};

export default OfferReducer;
